import { ApiScan, getScanTemplateRootQueryKey } from '@kaiizen/kai-pro-api';
import { useCachedQuery } from '@kaiizen/react-persistent-cache';

import { useKaiProApiClient } from '../useKaiProApiClient';
import { ScanOfflineDataMinTtlOnAccessMs } from './ScanStateLib';

export const useScanTemplateRoot = (scanTemplateId?: string, versionAt?: Date, prefetchOnly: boolean = false) => {
  const kaiProApiClient = useKaiProApiClient();

  const scanTemplateQuery = useCachedQuery(
    getScanTemplateRootQueryKey(scanTemplateId, versionAt),
    async () => kaiProApiClient.getScanTemplateRoot(scanTemplateId!, versionAt),
    {
      enabled: !!kaiProApiClient.token && !!scanTemplateId,
      staleAgeMs: versionAt ? Infinity : undefined,
      prefetchOnly,
      minTtlOnAccessMs: ScanOfflineDataMinTtlOnAccessMs,
    },
  );

  return {
    ...scanTemplateQuery,
    scanTemplateRoot: scanTemplateQuery.data,
  };
};

export const useScanTemplateRootForScan = (scan: ApiScan | undefined, prefetchOnly: boolean = false) =>
  useScanTemplateRoot(scan?.scanTemplateId, scan?.scanTemplateAt, prefetchOnly);
